import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import YesNoQuestionnaire from 'components/shared/YesNoQuestionnaire';
import { RadioButtonLegend } from '../AssistedPassengerSelection.styles';
import { noPassengers } from '../../../BookingMagnet.constants';
import { questions } from '../AssistedPassengerSelection.constants';

const CompanionOnlyPassengerSelection = ({ onChangePassengers }) => (
  <YesNoQuestionnaire
    onAllAnswersSelected={(answers) => {
      onChangePassengers({
        ...noPassengers,
        nonWheelchairCompanions: answers[questions.COMPANION_WHEELCHAIR_SPACE] ? 0 : 1,
        wheelchairCompanions: answers[questions.COMPANION_WHEELCHAIR_SPACE] ? 1 : 0
      });
    }}
    questions={[
      {
        name: questions.COMPANION_WHEELCHAIR_SPACE,
        legend: (
          <RadioButtonLegend>
            <FormattedMessage id="wheelchairSearch.questions.requireWheelchairSpace" />
          </RadioButtonLegend>
        )
      }
    ]}
  />
);

CompanionOnlyPassengerSelection.propTypes = {
  onChangePassengers: PropTypes.func.isRequired
};

export default CompanionOnlyPassengerSelection;
